export default {
  setMeshUrl (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setMeshUrl", payload)
      resolve()
    })
  }
}
